<template>
	<div>
		<ed-modal 
			:title="formData.id == 0 ? 'Nova Conclusão Técnica' : 'Editar Conclusão Técnica'" 
			:modal="showFormEdit" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="85%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="formData" :config="config" :response="response" :itens="exameItems">
					<div slot="form-footer"></div>
				</ed-form>
			</div>
		</ed-modal>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import EdModal from 'common/modal';
	import FormItems  from './_form/conclusao-cadastrar';

  	export default {
  		name:"exame-editar",
  		components: {EdForm,EdModal},
		mixins:[Rest],
		props:{
            conclusao_tecnica:{
                type: Object,
                default: null
			},
			parent:{
                type: Object,
                default: null
			},
			showForm:{
				type: Boolean,
                default: false
			}
        },
		watch: {
			'conclusao_tecnica.id'(){
			},
			showForm(){
				this.showFormEdit = !this.showFormEdit;
				this.init();
				if(this.conclusao_tecnica.id != 0){
					this.getConclusaoTecnica();
				}
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[92,96,100],
					hidden:{
						padrao:true
					},
					click:{
						id_esocial_procedimento:this.getEscocialTabela
					},
					loading:{
						save:false,
						content:false,
						id_esocial_procedimento:false,
					},
					list:{
						id_esocial_procedimento:[]
					}
				},
		   		formData:{
		   			id:0,
		   			nome:null,
		   			descricao:null,
		   			updated_at:null,
					usuario:null,
					ativo:1
		   		},
				response:{},
				exameItems:[],
				showFormEdit:false,
			}
		},

		mounted() {
			this.exameItems = FormItems;
		},

		methods: {

			init(){
				this.formData = {
					id:0,
		   			nome:null,
		   			descricao:null,
		   			updated_at:null,
					usuario:null,
					ativo:1
				};
			},
			
			getConclusaoTecnica(){

				this.config.loading.content = true;
				this.formData = {};
				this.response = {};

				this.get('conclusao-tecnica/'+this.conclusao_tecnica.id).then((result)=>{

		            result = result[0];

					this.response = result;
		            this.config.loading.content = false;

		            if(result.status == 200){
						this.formataData(result);
		            }
		        });
			},

			formataData(result){
				this.formData = {
					id:result.data.id,
					nome:result.data.nome,
					descricao:result.data.descricao,
					usuario:result.data.usuario,
					updated_at:result.data.updated_at,
					ativo:result.data.ativo
				};
			},

			salvar(){

				this.response = {};
				this.config.loading.save = true;

				this.post('conclusao-tecnica/editar',this.formData).then((result)=>{

					result = result[0];

					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Registro salvo com sucesso!');
						this.formataData(result);
						this.showFormEdit = !this.showFormEdit;

						if(this.parent.getConclusaoTecnica)
							this.parent.getConclusaoTecnica();
					}

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// editar.vue?10759cdb